const descuentos = [
    {
		tag: "HH25 15",
		porcentaje: 15,
	}, 
    {
		tag: "HH25 20",
		porcentaje: 20,
	}, 
    {
		tag: "HH25 30",
		porcentaje: 30,
	},  
    {
		tag: "HH25 40",
		porcentaje: 40,
	},  
    {
		tag: "HH25 50",
		porcentaje: 50,
	}, 
    {
		tag: "HH25 20% ACCESORIO",
		porcentaje: 20,
	},
    {
		tag: "HH25 60",
		porcentaje: 60,
	},
    {
		tag: "ULTIMAS TA",
		porcentaje: 30,
	},
    {
		tag: "ULTIMAS TAL",
		porcentaje: 40,
	},
     {
		tag: "ARCHIVE SALE",
		porcentaje: 20,
	},
    {
		tag: "ARCHIVE SALE",
		porcentaje: 50,
	},
   {
		tag: "Mid Seaso",
		porcentaje: 2,
	},
];

function formatTag(tag) {
	return tag.toLowerCase().trim();
}

function urlContainsX() {
  const url = document.URL
  if(url.includes('-de'))return true
  if(url.includes('-eu'))return true
  if(url.includes('-fr'))return true
  if(url.includes('-it'))return true
  if(url.includes('-nl'))return true
  return false;
}

function isRestrictedDiscount(tag) {
  const restrictedTags = ["MID SEASON 10%", "MID SEASON 15%"];
  return restrictedTags.includes(tag);
}

function urlContainsXPT() {
  const url = document.URL
  if(url.includes('-pt'))return true
  return false;
}

function isRestrictedDiscountPT(tag) {
  const restrictedTags = ["SPECIAL PRICES PT"];
  return restrictedTags.includes(tag);
}

function applyDiscounts(){
  $(".product-card").each(function () {
	const tags = $(this).attr("tags").split(",");
	tags.forEach((tag) => {
		if (descuentos.some((t) => formatTag(t.tag) == formatTag(tag))) {

          if (isRestrictedDiscount(tag) && !urlContainsX()) {
            return;
          }
           if (isRestrictedDiscountPT(tag) && !urlContainsXPT()) {
            return;
          }
          
			const comparePrice = parseInt($(this).attr("originalPrice")) / 100;
            let porcentaje = null;
            let cantidad = null;
            let price = null;
          
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje){
    			porcentaje = 100 - descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje;
                price = (comparePrice * porcentaje / 100).toFixed(2)              
            }
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad){
    			cantidad = descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad;
                price = (comparePrice - cantidad).toFixed(2)   
                porcentaje = (price * 100 / comparePrice).toFixed(0)
            }         
          if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje){
            $(this).find('.badges-custom').append(`<span class="badge-item_offer" style="${tags.join('').includes('OUTLET') ? 'background:#5cd1c8;color:#000000' : 'background:#5cd1c8;color:#000000'}">-${100 - porcentaje}%</span>`)            
          }
          if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad){
            $(this).find('.badges-custom').append(`<span class="badge-item_offer" style="background:#ffffff;color:#000000">-${cantidad}€</span>`)            
          }
			$(this).find(".apply-discount").html(`
              <sale-price class="h6 text-on-sale">
                <span class="sr-only">Precio de oferta</span>${price.toString().replace(".", ",")}€ EUR</sale-price>
                <compare-at-price class="h6 text-subdued line-through">
              <span class="sr-only">Precio normal</span>${comparePrice.toString().replace(".", ",")}€ EUR</compare-at-price>
            `);
		}
	});
});
}

function applyCartDiscounts(){
  return false;
  $(".line-item").each(function () {
	const tags = $(this).attr("tags").split(",");
	tags.forEach((tag) => {
		if (descuentos.some((t) => formatTag(t.tag) == formatTag(tag))) {

          if (isRestrictedDiscount(tag) && !urlContainsX()) {
            return;
          }
          if (isRestrictedDiscountPT(tag) && !urlContainsXPT()) {
            return;
          }
          
			const comparePrice = parseInt($(this).attr("originalPrice")) / 100;
            let porcentaje = null;
            let cantidad = null;
            let price = null;
          
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje){
    			porcentaje = 100 - descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje;
                price = (comparePrice * porcentaje / 100).toFixed(2)              
            }
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad){
    			cantidad = descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad;
                price = (comparePrice - cantidad).toFixed(2)   
                porcentaje = (price * 100 / comparePrice).toFixed(0)
            }         
          if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje){
            $(this).find('.badges-custom').html(`<span class="badge-item_offer" style="background:#d33136;color:#000000">-${100 - porcentaje}%</span>`)            
          }
          if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad){
            $(this).find('.badges-custom').html(`<span class="badge-item_offer" style="background:#d33136;color:#000000">-${cantidad}€</span>`)            
          }
			$(this).find(".apply-discount").html(`
               <price-list class="price-list apply-discount "><sale-price class="h6 text-on-sale">
      <span class="sr-only">Precio de oferta</span>${price.toString().replace(".", ",")}€ EUR</sale-price><compare-at-price class="h6 text-subdued line-through">
        <span class="sr-only">Precio normal</span>${comparePrice.toString().replace(".", ",")}€ EUR</compare-at-price></price-list>
        
            `);
		}
	});
});
}

function applyDiscount(){
  const tags = $(".product-info__block-list").attr("tags").split(",");
	tags.forEach((tag) => {
		if (descuentos.some((t) => formatTag(t.tag) == formatTag(tag))) {

          if (isRestrictedDiscount(tag) && !urlContainsX()) {
            return;
          }

           if (isRestrictedDiscountPT(tag) && !urlContainsXPT()) {
            return;
          }
          
			const priceText = $(".product-info__block-list").find(".apply-discount.price-list--product").children("sale-price").text().trim().match(/\d+\,\d+|\d+/g)[0];
			const comparePrice = parseFloat(priceText.replace(",", "."));            
            let porcentaje = null;
            let cantidad = null;
            let price = null;
          
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje){
    			porcentaje = 100 - descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).porcentaje;
                price = (comparePrice * porcentaje / 100).toFixed(2)              
            }
            if(descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad){
    			cantidad = descuentos.find((t) => formatTag(t.tag) == formatTag(tag)).cantidad;
                price = (comparePrice - cantidad).toFixed(2)   
                porcentaje = (price * 100 / comparePrice).toFixed(0)
            }    

          
            $(".product-info__block-list").find(".apply-discount.price-list--product").children("sale-price").removeClass("text-subdued");
            $(".product-info__block-list").find(".apply-discount.price-list--product").children("sale-price").addClass("text-on-sale");
            $(".product-info__block-list").find(".apply-discount.price-list--product").children("sale-price").html(`<span class="sr-only">Precio de oferta</span>${price.toString().replace(".", ",")}€ EUR`);
            
            $(".product-info__block-list").find(".apply-discount.price-list--product").children("compare-at-price").html(`<span class="sr-only">Precio normal</span>${comparePrice.toString().replace(".", ",")}€ EUR`)
    		$(".product-info__block-list").find(".apply-discount.price-list--product").children("compare-at-price").removeAttr('hidden')
            
		}
	});
}

if (document.URL.includes("/products/")) {
	applyDiscount()
}

if(document.URL.includes("/collections/")){
  var urlActual = document.URL;
    setInterval(function() {
      if (document.URL !== urlActual) {
        urlActual = document.URL;
        console.log('new page')
        setTimeout(()=>{
          applyDiscounts()
        },200)
      }
    }, 1000); 
}

applyDiscounts()
//applyCartDiscounts()

let lastSize = $('.variant-picker__option-values input:checked').val()
$('.block-swatch').click(function(){
  if($('.block-swatch:not(.is-disabled)').length < 2) return false
  setTimeout(()=>{
    const size = $(this).text().trim()
    if(lastSize != null && lastSize != size){
      applyDiscount()
      lastSize=size
    } 
    if(lastSize == null){
       applyDiscount()
       lastSize=size
    }
  },5)
})

